import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefRankingDisposition } from './interface/IRefRankingDisposition';

@Entity('ref_ranking_disposition')
export class RefRankingDisposition extends BaseEntity implements IRefRankingDisposition{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
